import React from 'react';
import { Box, TextButton } from '@wix/design-system';

interface CollapseButtonProps {
  totalCount: number;
  visibleCount: number;
  initialCount: number;
  onShowMore: () => void;
  onShowFewer: () => void;
  showMoreText: string;
  showFewerText: string;
}

const CollapseButton: React.FC<CollapseButtonProps> = ({
  totalCount,
  visibleCount,
  initialCount,
  onShowMore,
  onShowFewer,
  showMoreText,
  showFewerText,
}) => {
  if (totalCount <= initialCount) return null;

  const isShowingAll = visibleCount >= totalCount;

  if (isShowingAll) {
    return (
      <Box align="center" marginTop="24px">
        <TextButton
          skin="dark"
          underline="always"
          onClick={onShowFewer}
          dataHook="show-fewer-button"
        >
          {showFewerText}
        </TextButton>
      </Box>
    );
  }

  const hasMoreItems = totalCount > visibleCount;

  if (hasMoreItems) {
    return (
      <Box align="center" marginTop="24px">
        <TextButton
          skin="dark"
          underline="always"
          onClick={onShowMore}
          dataHook="show-more-button"
        >
          {showMoreText}
        </TextButton>
      </Box>
    );
  }

  return null;
};

export default CollapseButton;
